module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-camps"
  }, [_c('div', {
    staticClass: "school-camps__header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale].title))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.openCreateModal
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].create))])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "color": "blue"
    }
  }) : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].camp_title))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].classes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].from_date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].to_date))]), _vm._v(" "), _c('th', {
    staticClass: "th-hours"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].teaching_hours))]), _vm._v(" "), _c('th', {
    staticClass: "th-hours"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].remaining_hours))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].users))]), _vm._v(" "), _c('th', {
    staticClass: "th-actions"
  })])]), _vm._v(" "), _c('tbody', [(_vm.camps.length === 0) ? _c('tr', [_c('td', {
    staticClass: "school-camps__empty",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_camps))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.camps), function(camp) {
    return _c('tr', {
      key: camp.id,
      staticClass: "camp-row",
      on: {
        "click": function($event) {
          return _vm.openEditModal(camp)
        }
      }
    }, [_c('td', {
      staticClass: "td-title"
    }, [_vm._v(_vm._s(camp.title))]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v(_vm._s(_vm.getCalendarNamesByType(camp.calendar_ids, 'klass')))]), _vm._v(" "), _c('td', {
      staticClass: "td-datetime"
    }, [_vm._v(_vm._s(_vm.formatDateTime(camp.from_time)))]), _vm._v(" "), _c('td', {
      staticClass: "td-datetime"
    }, [_vm._v(_vm._s(_vm.formatDateTime(camp.to_time)))]), _vm._v(" "), _c('td', {
      staticClass: "td-hours"
    }, [_vm._v(_vm._s(camp.teaching_hours != null ? parseFloat(camp.teaching_hours.toFixed(2)) : ''))]), _vm._v(" "), _c('td', {
      staticClass: "td-hours"
    }, [_vm._v(_vm._s(camp.remaining_hours != null ? parseFloat(camp.remaining_hours.toFixed(2)) : ''))]), _vm._v(" "), _c('td', {
      staticClass: "td-calendars"
    }, [_vm._v(_vm._s(_vm.getCalendarNamesByType(camp.calendar_ids, 'user')))]), _vm._v(" "), _c('td', {
      staticClass: "td-actions",
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('button', {
      staticClass: "do-bttn do-bttn--small",
      on: {
        "click": function($event) {
          return _vm.openEditModal(camp)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "do-bttn do-bttn--small do-bttn--danger",
      on: {
        "click": function($event) {
          _vm.theDeleteCamp = camp
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])])
  })], 2)]), _vm._v(" "), (_vm.isModal) ? _c('div', {
    staticClass: "camp-create text-dark"
  }, [_c('DModal', {
    attrs: {
      "show-close": false,
      "placeInTop": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "camp-create__modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "camp-create__header"
  }, [_c('h3', [(!_vm.theEditCamp) ? _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].create))]) : _c('span', [_vm._v(_vm._s(_vm.form.title))])]), _vm._v(" "), _c('div', {
    staticClass: "camp-create__close icon__bg-circle",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('form', {
    staticClass: "camp-create__body",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "camp-create__grid"
  }, [_c('div', {
    staticClass: "camp-create__form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].camp_title))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    ref: "titleInput",
    staticClass: "d-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.i18n[_vm.locale].title_placeholder
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-list2"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].add_classes))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "klass",
      "preSelectedItems": _vm.form.klassCalendarIds
    },
    on: {
      "update": _vm.setSelectedKlasses
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].add_users))]), _vm._v(" "), _c('DSelectCalendarIds', {
    attrs: {
      "itemType": "USER",
      "preSelectedItems": _vm.form.userCalendarIds,
      "showTags": true
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "date-time-input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].from_date))]), _vm._v(" "), _c('div', {
    staticClass: "date-time-row"
  }, [_c('div', {
    staticClass: "date-field date-time-row__date"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.form.fromTime,
      "width100": true,
      "minDate": _vm.schoolYearMinDate,
      "maxDate": _vm.schoolYearMaxDate
    },
    on: {
      "changed": _vm.onFromDateChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-with-icon"
  }, [_c('div', {
    staticClass: "icon icon-clock"
  }), _vm._v(" "), _c('time-input', {
    attrs: {
      "date": _vm.form.fromTime
    },
    on: {
      "changed": _vm.onStartTimeInput
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "date-time-input-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].to_date))]), _vm._v(" "), _c('div', {
    staticClass: "date-time-row"
  }, [_c('div', {
    staticClass: "date-field date-time-row__date"
  }, [_c('DateSelector', {
    attrs: {
      "date": _vm.form.toTime,
      "width100": true,
      "minDate": _vm.schoolYearMinDate,
      "maxDate": _vm.schoolYearMaxDate
    },
    on: {
      "changed": _vm.onToDateChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-with-icon"
  }, [_c('div', {
    staticClass: "icon icon-clock"
  }), _vm._v(" "), _c('time-input', {
    attrs: {
      "date": _vm.form.toTime
    },
    on: {
      "changed": _vm.onEndTimeInput
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "input-group marg-1-top"
  }, [_c('label', [_vm._v(_vm._s(_vm.i18n[_vm.locale].available_time))]), _vm._v(" "), _c('div', {
    staticClass: "camp-toggle"
  }, [_c('div', {
    staticClass: "camp-toggle__option",
    class: {
      'camp-toggle__option--selected': _vm.form.useAdditionalTasks
    },
    on: {
      "click": function($event) {
        _vm.form.useAdditionalTasks = true
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "use_additional_tasks"
    },
    domProps: {
      "checked": _vm.form.useAdditionalTasks
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "camp-toggle__option-text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Indregnes i arbejdstiden (1/3) som øvrig opgave")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].add_to_tasks))])])]), _vm._v(" "), _c('div', {
    staticClass: "camp-toggle__option",
    class: {
      'camp-toggle__option--selected': !_vm.form.useAdditionalTasks
    },
    on: {
      "click": function($event) {
        _vm.form.useAdditionalTasks = false
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "use_additional_tasks"
    },
    domProps: {
      "checked": !_vm.form.useAdditionalTasks
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "camp-toggle__option-text"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Udbetales som engangsydelse")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale].pay_out))])])])])])]), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('div', {
    staticClass: "camp-create__sidebar"
  }, [_c('div', {
    staticClass: "camp-create__sidebar-desc"
  }, [_c('h3', [_vm._v(_vm._s(_vm.i18n[_vm.locale].existing_hours))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale].existing_hours_desc))])]), _vm._v(" "), _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].person))]), _vm._v(" "), _c('th', {
    staticClass: "td-number"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].in_schedule))]), _vm._v(" "), _c('th', {
    staticClass: "th-hours"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].hours_label))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedUsers), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticClass: "td-number"
    }, [_vm._v("\n                      " + _vm._s(_vm.formatMinutesToHours(_vm.scheduledHours[user.id])) + "t\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "td-hours"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.form.existingHours[user.id]),
        expression: "form.existingHours[user.id]",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "d-input td-hours__input",
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": "0",
        "step": "any"
      },
      domProps: {
        "value": (_vm.form.existingHours[user.id])
      },
      on: {
        "focus": function($event) {
          return $event.target.select()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.existingHours, user.id, _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })])])
  }), 0)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group input-group__submit marg-1-top"
  }, [_c('div', {
    staticClass: "input-group__submit__left"
  }, [(_vm.theEditCamp) ? [_c('button', {
    staticClass: "bttn--warning",
    on: {
      "click": function($event) {
        _vm.theDeleteCamp = _vm.theEditCamp
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })])] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "camp-create__guide",
    attrs: {
      "href": "https://app.docendo.dk/app#/helpdesk?article=239",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon-question3"
  }), _vm._v("\n                " + _vm._s(_vm.i18n[_vm.locale].guide) + "\n              ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "input-group__submit__right"
  }, [_c('button', {
    staticClass: "marg-1-right do-bttn",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].cancel))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    attrs: {
      "disabled": !_vm.isFormValid
    },
    on: {
      "click": _vm.saveCamp
    }
  }, [_vm._v("\n                " + _vm._s(_vm.theEditCamp ? _vm.i18n[_vm.locale].save : _vm.i18n[_vm.locale].create) + "\n              ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-overlay animatedFast fadeIn"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.theDeleteCamp) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isSubmitButtonLoading": _vm.isDeleting
    },
    on: {
      "close": function($event) {
        _vm.theDeleteCamp = null
      },
      "confirm": _vm.deleteCamp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ec8b891!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SchoolCamps.vue
// module id = 1949
// module chunks = 1